import {Component} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {Page} from "../../orchestration/page";
import {OrderModel} from "../../order/order.model";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {OrderingPhase, SessionEvents} from "../../orchestration/session-events";

@Component({
    selector: "woa-tip-selection-page",
    templateUrl: "./tip-selection-page.component.html",
    providers: [{provide: Page, useExisting: TipSelectionPageComponent}]
})
export class TipSelectionPageComponent extends Page {
    OrderingPhase = OrderingPhase;
    SessionEvents = SessionEvents;

    tipAmount: number;
    tipSelected: boolean = false;

    constructor(private navigationService: NavigationService,
                public orderModel: OrderModel,
                public orderingContextModel: OrderingContextModel) {
        super();
        this.tipAmount = this.orderModel.tipAmount;
    }

    get title(): string {
        return this.orderingContextModel.currentStore.tipInstructions ? "woa.message.tip.instructions" : "woa.message.tip.default";
    }

    get instructionParams(): any {
        return {instructions: this.orderingContextModel.currentStore.tipInstructions};
    }

    async applyTip(confirmed: boolean): Promise<any> {
        if (SessionEvents.orderingPhase$.value === OrderingPhase.PAYMENT && !confirmed) {
            return;
        }
        this.orderModel.tipAmount = this.tipAmount;
        this.orderingContextModel.tipSelected = this.tipSelected;
        return this.navigationService.dismissPage(this, true);
    }
}



// WEBPACK FOOTER //
// ./src/app/payment/tip-selection-page/tip-selection-page.component.ts